<div class="flex flex-col" [style.gap]="gap()" [style.margin-bottom]="gap()">
  <ng-content />
</div>
